import React from "react";
import "./Dashboard.css";
import Breadcrumb from "../../Layout/Breadcrumb/Breadcrumb";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import Nav from "../../Layout/Nav/Nav";
import LoginImage from "../../../Images/login.jpg";
import { Link } from "react-router-dom";
import { Chart } from "react-google-charts";

import Sidebar from "../../Layout/Nav/Sidebar/Sidebar";

function Dashboard() {
  const pie_chart1_data = [
    ["Task", "Hours per Day"],
    ["Nof open jobs", 8],
    ["Nof completed jobs", 2],
  ];

  const pie_chart2_data = [
    ["Task", "Hours per Day"],
    ["Total invoiced", 8],
    ["Nof completed", 6],
  ];

  const line_chart_data = [
    ["Days", "Nof Jobs", "Nof Invoices"],
    ["2024/12/31", 10, 5],
    ["2025/01/01", 40, 35],
    ["2025/01/02", 50, 25],
    ["2025/01/03", 25, 25],
    ["2025/01/04", 30, 15],
    ["2025/01/05", 20, 10],
    ["2025/01/06", 10, 5],
  ];

  const options = {
    // title: "Company Performance",
    legend: { position: "bottom" },
    // hAxis: {
    //   title: "Year",
    //   gridlines: { count: 15 },
    // },
    // vAxis: {
    //   title: "Sales",
    //   gridlines: { color: "none" },
    // },
    // colors: ["#a52714", "#097138"],
    // lineWidth: 4,
    // intervals: { style: "area" }, // Adds area intervals
  };

  return (
    <div className="page-con">
      <div className="page-nav">
        <Nav />
        {/* <div className="main"> */}
        {/* <Sidebar/> */}
      {/* </div> */}
      </div>

      <div className="page-body">
        <Header />
        {/* <Breadcrumb/> */}

        <div className="comb-sec breadcrumb-sec">
          <div className="container-fluid px-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb my-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <span>Dashboard</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div
          className="cl-mcont"
          style={{ marginTop: "-30px", paddingLeft: "30px" }}
        >
          <div className="row">
            <div className="col-md-12 col-sm-6"></div>

            <div className="col-md-3 col-sm-6">
              <div className="fd-tile detail clean tile-purple">
                <div className="content">
                  <h1 className="text-left">20</h1>
                  {/* <p>xxx </p> */}
                </div>
                <div className="icon">
                  <i className="fa"></i>
                </div>
                <span className="details" style={{ textDecoration: "none" }}>
                  Todays' Job
                  <span>
                    {/* <svg
                      style={{
                        width: "18px",
                        float: "right",
                        // backgroundColor: "rgba(255, 255, 255, 0.4)",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1 .4 34.4z" />
                    </svg> */}
                  </span>
                </span>
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="fd-tile detail clean tile-green">
                <div className="content">
                  <h1 className="text-left">15</h1>
                  <p></p>
                </div>
                <div className="icon">
                  <i className="fa"></i>
                </div>
                <span className="details" style={{ textDecoration: "none" }}>
                  Todays' Invoice
                  <span></span>
                </span>
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="fd-tile detail clean tile-prusia">
                <div className="content">
                  <h1 className="text-left">USD 3,400</h1>
                  <p></p>
                </div>
                <div className="icon">
                  <i className="fa"></i>
                </div>
                <span className="details" style={{ textDecoration: "none" }}>
                  Todays' Receipt
                  <span></span>
                </span>
              </div>
            </div>

            <div className="col-md-3 col-sm-6">
              <div className="fd-tile detail clean tile-red">
                <div className="content">
                  <h1 className="text-left">5500</h1>
                  <p></p>
                </div>
                <div className="icon">
                  <i className="fa"></i>
                </div>
                <span className="details" style={{ textDecoration: "none" }}>
                  Total Customers
                  <span></span>
                </span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <br></br>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="block widget-notes">
                <div className="header dark">
                  <h4>JOB PROGRESS</h4>
                </div>
                <div className="content chart-content">
                  <Chart
                    width={"480px"}
                    height={"300px"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={pie_chart1_data}
                    options={{
                      title: "",
                      colors: [
                        "#7761a7",
                        "#3d566d",
                        "#D8A7B1",
                        "#FFC107",
                        "#D3D3D3",
                      ],
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="block widget-notes">
                <div className="header dark">
                  <h4>INVOICE PROGRESS</h4>
                </div>
                <div className="content chart-content">
                  <Chart
                    width={"480px"}
                    height={"300px"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={pie_chart2_data}
                    options={{
                      title: "",
                      colors: [
                        "green",
                        "orange",
                        "#D8A7B1",
                        "#FFC107",
                        "#D3D3D3",
                      ],
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <br></br>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="block ">
                <div className="block widget-notes">
                  <div className="header dark">
                    <h4>RECENT JOBS</h4>
                  </div>

                  <div className="content">
                    <div className="table-responsive">
                      <table className="table no-border hover">
                        <thead className="no-border">
                          <tr>
                            <th>
                              <strong>Job No</strong>
                            </th>
                            <th>
                              <strong>Date</strong>
                            </th>
                            <th>
                              <strong>Customer </strong>
                            </th>
                            <th className="text-right">
                              <strong>Status</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="no-border-y">
                          <tr>
                            <td>Job-0001</td>
                            <td>2021-08-12</td>
                            <td>Mohammed Rahmy</td>
                            <td>Pending</td>
                          </tr>
                          <tr>
                            <td>Job-0002</td>
                            <td>2021-08-12</td>
                            <td>Vinoth</td>
                            <td>Completed</td>
                          </tr>
                          <tr>
                            <td>Job-0003</td>
                            <td>2021-08-12</td>
                            <td>Siva</td>
                            <td>Cancelled</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="block">
                <div className="block widget-notes">
                  <div className="header dark">
                    <h4> RECENT RECEIPTS</h4>
                  </div>

                  <div className="content">
                    <div className="table-responsive">
                      <table className="table no-border hover">
                        <thead className="no-border">
                          <tr>
                            <th>
                              <strong>Rcpt No</strong>
                            </th>
                            <th>
                              <strong>Job No</strong>
                            </th>
                            <th>
                              <strong>Amount </strong>
                            </th>
                            <th className="text-right">
                              <strong>Status</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="no-border-y">
                          <tr>
                            <td>RCT-0001</td>
                            <td>Job-0001</td>
                            <td>USD 10,000.00</td>
                            <td>Pending</td>
                          </tr>
                          <tr>
                            <td>RCT-0002</td>
                            <td>Job-0001</td>
                            <td>USD 10,000.00</td>
                            <td>Cancelled</td>
                          </tr>
                          <tr>
                            <td>RCT-0003</td>
                            <td>Job-0001</td>
                            <td>USD 20,000.00</td>
                            <td>Success</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <br></br>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="block widget-notes">
                <div className="header dark">
                  <h4>JOB PROGRESS</h4>
                </div>
                <div className="content chart-content">
                  <br></br>
                  <br></br>
                  <Chart
                    chartType="Line"
                    chartPackages={["corechart"]}
                    chartVersion="current"
                    width="100%"
                    height="400px"
                    data={line_chart_data}
                    options={options}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
export default Dashboard;
